import { Head, Link } from '@inertiajs/react'
import { Lock } from 'lucide-react'
import Logo from '@/components/Logo'
import { Button } from '@/components/ui/button'
import type { ReactNode } from 'react'

type PrivateGateProps = {
  sign_in_path: string
  sign_up_path: string
}

// Anonymous visitors hitting a private event land here. It carries zero event
// details (no title, org, date, or OG tags) — only the invitation to sign in.
// A return path is preserved server-side, so authenticating sends the visitor
// back to the event.
export default function PrivateGate({ sign_in_path, sign_up_path }: PrivateGateProps) {
  return (
    <>
      <Head title="This event is private · Gala Season" />

      <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-background via-accent/10 to-primary/5 px-4">
        <div className="w-full max-w-md text-center">
          <div className="mb-8 flex justify-center">
            <Link href="/">
              <Logo />
            </Link>
          </div>

          <div className="rounded-2xl border border-black/10 bg-card p-8 shadow-xs">
            <div className="mx-auto mb-5 flex size-12 items-center justify-center rounded-full bg-primary/10">
              <Lock className="size-6 text-primary" />
            </div>

            <h1 className="text-2xl font-semibold tracking-tight text-foreground">This event is private</h1>

            <p className="mt-3 text-base text-foreground">
              This event is available to Gala Season members. Sign in to view it, or create a free account.
            </p>

            <div className="mt-7 space-y-3">
              <Button asChild className="w-full">
                <Link href={sign_in_path}>Sign in to view</Link>
              </Button>
              <p className="text-base text-muted-foreground">
                New here?{' '}
                <Link href={sign_up_path} className="font-medium text-primary underline underline-offset-4">
                  Create a free account
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

PrivateGate.layout = (page: ReactNode) => page
